import React, { useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const StyledLink = styled(Link)`
  text-decoration: none;
`
const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-inline: 5% 5%;
`

const StyledMessage = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
  margin-block: 2rem;
`;

const StyledCopy = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 30%;

  @media screen and (max-width: 1188px) {
    max-width: 500px;
    margin-block: 1rem;
  }
`;

const StyledH1 = styled.h1`
  text-align: center;
`;

const StyledImage = styled.img`
  max-width: 100%;
  height: auto;
  max-height: 700px;
  border-radius: 10px;
  transition: all 0.3s ease;
  align-self: center;
`;

const StyledImageArea = styled.div`
  @media screen and (max-width: 1188px) {
    text-align: center;
    width: 100%;
  }
`;

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <AboutContainer>
      <StyledMessage>
        <StyledCopy>
          <StyledH1>Meditate with us</StyledH1>
          <p>
            The sangha meets virtually on Tuesday evenings at 7:15pm US Eastern
            Time via Zoom and on the first Saturday of each month for
            a morning of mindfulness.
          </p>
          <p>
            If you are interested in the history of our sangha, take a look at our <StyledLink to="/history">history page</StyledLink>.
          </p>
        </StyledCopy>
        <StyledImageArea>
          <StyledImage
            src="https://d3lar93zsohcaj.cloudfront.net/herons/heron_in_algae.jpg"
            alt="Blue heron standing in algae"
          />
        </StyledImageArea>
      </StyledMessage>
      <StyledMessage>
        <StyledImageArea>
          <StyledImage
            src="https://d3lar93zsohcaj.cloudfront.net/herons/two_herons.jpg"
            alt="Two blue herons"
          />
        </StyledImageArea>
        <StyledCopy>
          <StyledH1>Try it and see for yourself</StyledH1>
          <p>
            To meditate does not mean you give up other spiritual roots. The
            people who sit with Blue Heron are active in many faith traditions.
            We meditate to develop the energy of mindfulness, the energy of
            being present, aware and awake, as life is happening.
          </p>
        </StyledCopy>
      </StyledMessage>
      <StyledMessage>
      <StyledCopy>
          <StyledH1>What happens?</StyledH1>
          <p>We sit during different activities, done mostly in silence:</p>
          <ul>
            <li>
              Welcome and opening verse, inviting us to bring our minds into
              meditation
            </li>
            <li>
              Guided meditation, a series of gentle prompts about mindfulness
            </li>
            <li>
              Walking meditation, slowly walking, feet connecting with the
              ground, offers a stretch between sitting segments
            </li>
            <li>Silent sitting meditation, following the breath, in and out</li>
            <li>
              Singing, a brief song that embodies a principle of mindfulness
            </li>
            <li>Activity such as a recorded talk or a shared reading</li>
            <li>
              Sharing from the heart, a time for speaking from the heart,
              listening with compassion and kindness
            </li>
            <li>Closing verse</li>
            <li>Announcements, notices about upcoming events and news</li>
          </ul>
          <p>
            We also practice mindful movement, deep relaxation, and recite the
            Mindfulness Trainings, guides to conscious ethical living.
          </p>
        </StyledCopy>
        <StyledImageArea>
          <StyledImage
            src="https://d3lar93zsohcaj.cloudfront.net/herons/single_heron_standing.jpg"
            alt="Blue heron"
          />
        </StyledImageArea>
      </StyledMessage>
      <StyledMessage>
        <StyledImageArea>
          <StyledImage
            src="https://d3lar93zsohcaj.cloudfront.net/herons/heron_with_fish.jpg"
            alt="Blue heron"
          />
        </StyledImageArea>
        <StyledCopy>
          <StyledH1>What is mindfulness meditation?</StyledH1>
          <p>
            In meditation we develop the energy of mindfulness, the energy of
            being present, aware and awake, as life is happening. We learn to
            pause, to focus our attention (starting with the breath), to
            maintain that focus for a period of time, to begin anew when
            distractions arise, and not to judge ourselves when (not if!) we
            forget.
          </p>
          <p>
            We learn to be mindful of our body—its sensations,
            appearance, and movements. We learn to be mindful of our mind—its
            stream of thoughts, emotions, perceptions, and concepts. With
            practice, over time, we learn to bring mindful awareness into
            everyday activities--walking, driving, conversation, shopping,
            washing the dishes--so that we can be peaceful and fully present to
            all we do.
          </p>
          <p>
            With mindfulness, we learn to see and cultivate
            conditions of happiness, and we learn to recognize and transform
            factors that contribute to our suffering. Mindful meditation teaches
            us to see the interconnection we share with each other, with Mother
            Earth, and with all beings.
          </p>
        </StyledCopy>
      </StyledMessage>
    </AboutContainer>
  );
};

export default About;
